import React from 'react';

import TextBlock from '../Components/TextBlock';

const About = (props) => {
	return (
		<TextBlock name='Про нас'>
			<section className="s-text">
			Вітаємо на сайті нашої компанії, на ньому ви можете ознайомитись з тарифами та умовами надання найбільш популярних послуг. <br/>
            Наша компанія працює на ринку юридичних послуг з 2017 року, за цей час ми допомогли тисячам підприємців та сотням компаній.<br/>
			</section>
			<h4>Ми гарантуємо:</h4>
            <section className="s-textb">
                • оперативне і якісне виконання доручень;<br/>
                • лояльні ціни і зручні способи розрахунків; <br/>
                • індивідуальний підхід. 

			</section>
		</TextBlock>
	);
}

export default About;


// WEBPACK FOOTER //
// ./src/Page/About.jsx